import { v1 } from './v1';

export const cues = {
  v1,
};
